import intersection from 'lodash/intersection'
import isEmpty from 'lodash/isEmpty'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import ListCloseIcon from '@pc/components/Works/Panel/shared/List/ListCloseIcon'
import ListItem from '@pc/components/Works/Panel/shared/List/ListItem'
import ListItemName from '@pc/components/Works/Panel/shared/List/ListItemName'
import ListItemParagraph from '@pc/components/Works/Panel/shared/List/ListItemParagraph'
import ListOpenIcon from '@pc/components/Works/Panel/shared/List/ListOpenIcon'
import type { Line, Station } from '@pc/components/Works/Panel/types'
import StationCheckboxes from './StationCheckboxes'
import type { MouseEvent } from 'react'

interface PropsType {
  line: Line
  stations: Station[]
  selectedStationIds: string[]
  changeStationIds: (stationIds: string[]) => void
}

const LineListItem = styled(ListItem)`
  cursor: pointer;
  margin-left: 20px;
  transition: all 0.2s;
`

const LineListItemParagraph = styled(ListItemParagraph)`
  display: flex;
  position: relative;

  svg {
    position: absolute;
    right: 15px;
  }
`

const LineListItemName = styled(ListItemName)`
  min-width: 250px;
`

const LineItem = (props: PropsType) => {
  const { line, stations, selectedStationIds, changeStationIds } = props
  const [childrenIsOpen, setChildrenIsOpen] = useState(false)

  const toggleChildren = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault()
    setChildrenIsOpen(!childrenIsOpen)
  }

  useEffect(() => {
    const isSelectedBeforehand = !isEmpty(
      intersection(
        stations.map((station) => station.attributes.compat_id.toString()),
        selectedStationIds
      )
    )
    if (isSelectedBeforehand) {
      setChildrenIsOpen(true)
    }
  }, [stations, selectedStationIds])

  return (
    <LineListItem>
      <LineListItemParagraph onClick={toggleChildren}>
        <LineListItemName>{line.attributes.name}</LineListItemName>
        {childrenIsOpen ? <ListCloseIcon /> : <ListOpenIcon />}
      </LineListItemParagraph>
      {childrenIsOpen && (
        <StationCheckboxes line={line} stations={stations} selectedStationIds={selectedStationIds} changeStationIds={changeStationIds} />
      )}
    </LineListItem>
  )
}

export default LineItem
